<template>
  <div>
    <div class="detail-head-211130">
      <h3 class="payment-tab-title">
        <span class="on">订单信息</span>
      </h3>
      <div class="tip">
        收付款编号: {{ row.paymentsNum }} | 创建人: {{ row.createUser }}
        <span>| 创建日期: {{ row.createTime }}</span>
      </div>
    </div>
    <div class="clearfix">
      <div class="add-box clearfix">
        <vxe-table
            border
            show-overflow
            keep-source
            ref="t1"
            align="center"
            auto-resize
            highlight-hover-row
            class="table_insert"
            :data="ordersList"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
        >
          <vxe-table-column field="ordersNum" title="订单编号">
            <template v-slot="{ row }">
              <div>{{ row.ordersNum }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="relOrdersNum" title="关联主订单">
            <template v-slot="{ row }">
              <div class="link-text" @click="openOrderDetail(row)">
                {{ row.relOrdersNum }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="sellerName" title="销售方"></vxe-table-column>
          <vxe-table-column field="aboutAmount" title="金额"></vxe-table-column>
        </vxe-table>
      </div>

      <div class="tip-211130">
        <h3 class="title">收付款信息</h3>
      </div>
      <div class="row-table-sty clearfix">
        <vxe-form :data="formData" title-colon ref="xForm1" title-width="150" title-align="right">
          <vxe-form-item title="所属公司" field="compName" span="8">
            <template>
              <Tooltip :content="formData.compName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.compName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="业务员" field="salesMan" span="8">
            <template>
              <Tooltip :content="formData.salesMan" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.salesMan }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="客户名称" field="clientName" span="8">
            <template>
              <Tooltip :content="formData.clientName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.clientName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="日期" field="addTime" span="8" max-width="250">
            <template>
              <span class="row-table-txt">{{ formData.addTime }}</span>
            </template>
          </vxe-form-item>
          <vxe-form-item title="摘要" field="note" span="8">
            <template>
              <Tooltip :content="formData.note" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.note }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="支付凭证流水号" field="payBankCode" span="8">
            <template>
              <Tooltip :content="formData.payBankCode" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payBankCode }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="总金额" field="payAmount" span="8">
            <template>
              <Tooltip :content="formData.payAmount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payAmount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="已关联金额" field="usedAmount" span="8">
            <template>
              <Tooltip :content="formData.usedAmount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.usedAmount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="未关联金额" field="unusedAmount" span="8">
            <template>
              <Tooltip :content="formData.unusedAmount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.unusedAmount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
        </vxe-form>
        <vxe-form :data="formData" title-colon ref="xForm2" title-width="150" title-align="right">
          <vxe-form-item title="付款企业(人)名称" field="paymentsName" span="8">
            <template>
              <Tooltip :content="formData.paymentsName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.paymentsName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="开户行" field="payBank" span="8">
            <template>
              <Tooltip :content="formData.payBank" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payBank }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="银行卡号" field="payAccount" span="8">
            <template>
              <Tooltip :content="formData.payAccount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.payAccount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
        </vxe-form>
        <vxe-form :data="formData" title-colon ref="xForm3" title-width="150" title-align="right">
          <vxe-form-item title="收款企业(人)名称" field="recName" span="8">
            <template>
              <Tooltip :content="formData.recName" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.recName }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="开户行" field="recBank" span="8">
            <template>
              <Tooltip :content="formData.recBank" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.recBank }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
          <vxe-form-item title="银行卡号" field="recAccount" span="8">
            <template>
              <Tooltip :content="formData.recAccount" placement="top" max-width="250">
                <span class="row-table-txt">{{ formData.recAccount }}</span>
              </Tooltip>
            </template>
          </vxe-form-item>
        </vxe-form>
        <upload-table ref="uploadTable" v-if="tableData[0]" style="margin-top: 20px;" :row="tableData[0]"
                      :initFileList="tableData[0] && tableData[0].fileList ? tableData[0].fileList : []"
                      :isEdit="false"></upload-table>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import UploadList from "@/components/common/UploadList";
import BankAccount from "@/components/modal/BankAccount";
import Account from "@/components/modal/Account";
import PlatformCorp from "@/components/common/PlatformCorp";
import CustomerSelect from "@/components/common/CustomerSelect";
import SalesMan from "@/components/common/SalesMan";
import getAuthOrization from "@/mixin/getAuthOrization";
import {orderDetail, showLoading, hideLoading, isNotEmpty} from "@/utils/util";
import {isEmpty} from "xe-utils/methods";
import AboutCollectionOrder from "@/components/order/AboutCollectionOrder";
import UploadTable from "@/components/modal/UploadTable";

const assign = (val) => Object.assign({}, val);
const empties = [undefined, "", null, "null", {}, [], "[]"];

export default {
  mixins: [getAuthOrization],
  name: "CollectionDetail",
  components: {
    UploadTable,
  },
  props: {
    detailData: Object
  },
  data() {
    return {
      queryAction: "",
      updateAction: "",
      paymentId: 0,
      isShowChooseOrder: false,
      amountListName: "",
      isShowChooseAccount: false,
      isShowBankAccountModal: false,
      isEdit: false,
      ordersList: [], //关联的订单数据
      aboutOrderList: [],
      row: {},
      tableData: [], //详情收付款数据 只有一条
      selectTab: "tab1",
      usedAmount: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      allAboutOrderList: [],
      formData: {},
    };
  },
  methods: {
    openOrderDetail(id) {
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`,
      };
      window.open(obj.path);
      return false;
    },
    async init(paymentId) {
      this.paymentId = paymentId;
      this.getData();
    },
    checkTab(val) {
      this.selectTab = val;
    },
    setEdit(isEdit) {
      this.isEdit = isEdit;
    },
    async getData() {
      let res = await $api.twoPayments.request('queryPaymentsPayDetail', {
        id: this.paymentId,
      });
      if (res.status == 1) {
        let row = JSON.parse(JSON.stringify(res.data));
        this.orderTableData = [{
          ordersNumAttached: this.detailData.ordersNumAttached,
          relOrdersNum: this.detailData.relOrdersNum,
          sellerName: this.detailData.sellerName,
          saleMan: this.detailData.saleMan,
          clientManage: this.detailData.clientManage,
          relOrdersId: this.detailData.relOrdersId,
        }]
        //详情数据从详情接口去取
        if (row.addTime != null) {
          row.addTime = this.$utils.toDateString(row.addTime, "yyyy-MM-dd");
        }
        if (row.createTime != null) {
          row.createTime = this.$utils.toDateString(row.createTime, "yyyy-MM-dd");
        }
        if (empties.includes(row.ordersList) || row.ordersList.length == 0) {
          this.ordersList = [assign(this.orderTmp)];
          this.aboutOrderList = [assign(this.orderTmp)];
        } else {
          this.ordersList = row.ordersList.filter((item) => item.id == this.paymentId);
          this.usedAmount = row.ordersList.reduce((prev, cur) => {
            return Math.round(cur.aboutAmount * 100) / 100 + prev;
          }, 0);
          this.usedAmount = Math.round(this.usedAmount * 100) / 100;
          this.page.totalResult = row.ordersList.length;
          this.allAboutOrderList = row.ordersList;
          this.aboutOrderList = row.ordersList.slice(0, this.page.pageSize);
          row[this.amountListName] = row.ordersList;
        }

        this.ordersList[0].relOrdersNum = this.detailData.relOrdersNum;
        this.ordersList[0].sellerName = this.detailData.sellerName;
        this.ordersList[0].relOrdersId = this.detailData.relOrdersId;

        let a = this.ordersList;
        debugger

        row.unusedAmount = parseFloat(row.unusedAmount).toFixed(2);
        // 不能根据this.ordersList.length 来判断
        row.clientName = res.data.clientName;
        row.salesMan = res.data.salesMan;
        this.row = row;
        this.tableData = [row];
        this.formData = row;

        if (isEmpty(row.fileList) && undefined != this.$refs.uploadTable) {
          this.$refs.uploadTable.init([]);
        }
      } else {
        if (empties.includes(res.message)) {
          res.message = "接口异常";
        }
        this.$XModal.message({
          status: "error",
          message: res.message,
        });
      }
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "单页合计";
          }
          if (["aboutAmount"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "全部合计";
          }
          if (["aboutAmount"].includes(column.property)) {
            return this.usedAmount;
          }
          return null;
        }),
      ];
    },
  },
};
</script>
<style>
.detail-head {
  position: relative;
  height: 50px;
}

.detail-head .payment-tab-title {
  height: 50px;
  line-height: 50px;
  font-weight: normal;
}

.detail-head .payment-tab-title span {
  padding: 0 5px;
  cursor: pointer;
}

.detail-head .payment-tab-title span.on {
  font-weight: 700;
}

.detail-head .tip {
  position: absolute;
  right: 20px;
  top: 0;
  color: #606266;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
}

/* 详情 表格内样式 */
.link-text {
  color: #2d8cf0;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}

.inner-column {
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  margin: auto;
  line-height: 50px;
}

.inner-column-title {
  background-image: linear-gradient(#f8f8f9, #f8f8f9), linear-gradient(#f8f8f9, #f8f8f9);
  color: #808695;
  background-repeat: no-repeat;
  border-top: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  line-height: 50px;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
}

.large-name {
  text-align: center;
  vertical-align: middle !important;
  position: relative;
  padding: 0;
  clear: both;
}

.large-name-text {
  margin: auto;
  display: inline-block;
  word-wrap: break-word !important;
  word-break: normal !important;
  vertical-align: middle !important;
  width: 100%;
  margin-left: -8px;
  line-height: 24px;
}
</style>
